import {AbstractModel} from '../../../abstract-model';
import {ThemeSchemaStyle} from './theme-schema-style';
import {ThemeSchemaGroup} from './theme-schema-group';
import {ThemeSchemaElement} from './theme-schema-element';

export class ThemeSchema extends AbstractModel {
  elements: ThemeSchemaElement[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    for (const key in input) {
      const element = input[key];

      switch (element.type) {
        case'style':
          this.elements.push(new ThemeSchemaStyle().deserialize(element));
          break;
        case 'group':
          this.elements.push(new ThemeSchemaGroup().deserialize(element));
          break;
      }
    }

    return this;
  }
}
